/**
 * Live read of `settings/general.trialEndsAt` for the trial notice.
 *
 * Read straight from Firestore (members may read `settings/*`) rather than via
 * `core.tenant.settings()`, whose shape is the `TenantSettings` contract in
 * `@praesto/contracts`: surfacing one display-only field there would mean a
 * contract change for every module.
 */
import { getApp } from "firebase/app";
import { doc, getFirestore, onSnapshot, type Timestamp } from "firebase/firestore";

export type Unsubscribe = () => void;

/** Calls `cb` with the trial end, or `null` when the tenant has no trial. */
export function subscribeTrialEnd(tenantId: string, cb: (endsAt: Date | null) => void): Unsubscribe {
  return onSnapshot(
    doc(getFirestore(getApp("praesto")), `tenants/${tenantId}/settings/general`),
    (snap) => {
      const raw = snap.get("trialEndsAt") as Timestamp | undefined;
      cb(raw && typeof raw.toDate === "function" ? raw.toDate() : null);
    },
    // A failed read must not invent a trial: no notice is the safe default.
    () => cb(null),
  );
}
